import type { Channel, Coverage, OfferViewModel } from "@/api_client";

import { getEcommercePurchase } from "./data/ecommerce";
import insuranceInfo from "./data/insuranceInfo";
import objectInfo from "./data/objectInfo";
import processInfo from "./data/processInfo";
import productInfo from "./data/productInfo";
import type { PurchaseEvent } from "./types/types";

export const createPurchaseEvent = (
  contextId: string,
  offer: OfferViewModel,
  channel: Channel,
  coverageContent: Record<string, Coverage> | undefined,
): PurchaseEvent | undefined => {
  if (!offer?.quotes) {
    return;
  }
  const productInfoList = offer.quotes.map((product) =>
    productInfo.getProductInfo(product, channel),
  );
  const insuranceInfoList = offer.quotes.map((product) =>
    insuranceInfo.getInsuranceInfo(
      contextId,
      product,
      coverageContent,
      offer.offer?.purchaseTimestamp
        ? new Date(offer.offer?.purchaseTimestamp)
        : undefined,
    ),
  );
  const objectInfoList = offer.quotes.map((product) =>
    objectInfo.getObjectInfo(
      offer.enigmatized?.policyHolder,
      product,
      product.id && offer.enigmatized?.quotes
        ? offer.enigmatized.quotes[product.id]
        : undefined,
    ),
  );

  return {
    event: "Purchase",
    productInfo: productInfoList,
    insuranceInfo: insuranceInfoList,
    processInfo: processInfo.getProcessInfo("purchase"),
    ecommerce: getEcommercePurchase(contextId, offer, channel, coverageContent),
    objectInfo: objectInfoList,
  };
};
